import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  dialog: {
    "& .MuiBackdrop-root": {
      backgroundColor: "rgba(0,0,0,0.8);",
    },
    // event details sit at 999999 z-index, because the Freshchat widget is one below that
    // needs !important because zIndex is set by MUI at the element inline level, can't override otherwise
    zIndex: "1000000 !important" as unknown as 1000000,
  },
  form: {
    margin: "0px 10px",
  },
  actions: {
    padding: `${theme.spacing(1.5)} ${theme.spacing(3)}`,
    borderTopColor: theme.palette.gray.light,
    borderTopStyle: "solid",
    borderTopWidth: "1px",
  },
  header: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  inputs: {
    columnGap: theme.spacing(2),
  },
}));
